import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';
import { getActiveWorkspace } from '../utils/workspace';

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  // 不需要显示侧边栏和顶部导航栏的页面
  const noLayoutPages = ['/', '/login', '/admin-login'];
  const shouldShowLayout = !noLayoutPages.includes(location.pathname);
  const activeWorkspace = getActiveWorkspace(location.pathname);

  const handleToggleCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  if (!shouldShowLayout) {
    return <>{children}</>;
  }

  return (
    <div
      className={`${sidebarCollapsed ? 'app-sidebar--collapsed' : ''} workspace-${activeWorkspace}`}
      style={{ '--sidebar-width': sidebarCollapsed ? '64px' : '276px' }}
    >
      <div className="app-shell">
        <Sidebar
          isCollapsed={sidebarCollapsed}
          onToggleCollapse={handleToggleCollapse}
        />
        <div className="app-main">
          <TopNavbar isCollapsed={sidebarCollapsed} />
          <main className="app-content">
            <div className="app-content__inner">
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
